// Luật khung giờ vàng (THUẦN): 'HH:mm-HH:mm', tối đa 4 khung, không chồng lấn, cho qua nửa đêm.
export const MAX_GOLDEN_SLOTS = 4;

const toMin = (t) => {
    const [h, m] = String(t).split(":").map(Number);
    return h * 60 + m;
};
/** 'HH:mm-HH:mm' → các đoạn phút trong ngày (khung qua nửa đêm tách làm 2). */
export function slotSegments(slot) {
    const [a, b] = String(slot).split("-").map(toMin);
    if (a === b) return [];
    return a < b ? [[a, b]] : [[a, 1440], [0, b]];
}

/** @returns {string|null} câu lỗi tiếng Việt, null nếu hợp lệ. */
export function goldenHoursError(slots) {
    if (!slots.length) return "Cần ít nhất 1 khung giờ vàng (hoặc tắt nhiệm vụ này).";
    if (slots.length > MAX_GOLDEN_SLOTS) return `Tối đa ${MAX_GOLDEN_SLOTS} khung giờ.`;
    const segs = [];
    for (let i = 0; i < slots.length; i += 1) {
        const s = slotSegments(slots[i]);
        if (!s.length) return `Khung ${i + 1}: giờ bắt đầu và kết thúc không được trùng nhau.`;
        for (const [a, b] of s) {
            const hit = segs.find((x) => a < x.b && x.a < b);
            if (hit) return `Khung ${i + 1} bị chồng lên khung ${hit.i + 1}.`;
        }
        s.forEach(([a, b]) => segs.push({ a, b, i }));
    }
    return null;
}
